<template>
  <div class="view agent-login">

    <h1>{{ $t('menu.agent-login') }}</h1>

    <div class="alerts" v-if="error">
      <div class="alert-warning">{{ $t('login.invalid') }}</div>
    </div>

    <form-input type="text" :label="$t('general.label.username')" icon="name" v-model="username"/>
    <form-input type="password" :label="$t('general.label.password')" icon="password" ref="password" v-model="password" />
    <button class="button-login" @click="onSubmit">{{ $t('login.label') }}</button>

    <!-- <router-link class="forgot-password" :to="{name: 'agent-reset-password'}">{{ $t('login.forgot') }}</router-link> -->

  </div>
</template>

<script>
import FormInput from '@/components/FormInput.vue';
import Agent from '@/models/Agent';

export default {
  name: 'AgentLogin',

  data() {
    return {
      error: false,
      username: '',
      password: ''
    }
  },

  components: {
    FormInput
  },

  methods: {
    onSubmit() {
      this.error = false;
      Agent.login(this.username, this.password).then(() => {
        this.$router.replace({ name: 'agent' });
      }).catch(err => {
        this.error = true;
        this.password = '';
        this.$refs.password.$refs.formInputInput.focus();
      });
    }
  }
}
</script>

<style lang="scss">
.view.agent-login {
  @include small-page-layout;

  .component.form-input {
    @include form-layout-wide;
  }

  .name .icon { @include font-awesome($fa-var-user, light); }
  .password .icon { @include font-awesome($fa-var-lock-alt, light); }

  .button-login {
    @include button($colorCTA, #fff);
    width: 100%;
  }

  .forgot-password {
    margin-top: 25px;
    display: inline-block;
  }
}
</style>
